export default [
  {
    key: 'id',
    label: 'ID',
    sortable: false,
    filter: false,
    thClass: 'align-middle text-center',
    tdClass: 'align-middle text-center',
    show: false,
  },
  {
    key: 'external_id',
    label: 'Remote ID',
    sortable: false,
    filter: false,
    thClass: 'align-middle text-center',
    tdClass: 'align-middle text-center',
    show: true,
  },
  {
    key: 'net_amount',
    label: 'Amount',
    sortable: false,
    filter: false,
    thClass: 'align-middle text-center',
    tdClass: 'align-middle text-center',
    show: true,

  },
  {
    key: 'reason',
    label: 'Reason',
    sortable: false,
    filter: false,
    thClass: 'align-middle text-center',
    tdClass: 'align-middle text-center',
    show: true,
  },
]
